(() => {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-gr-mini-cart-clear]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;
    if (!window.confirm('Remove every item from your cart?')) return;

    const drawer = button.closest('cart-drawer');
    button.setAttribute('aria-disabled', 'true');
    button.textContent = 'CLEARING…';

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/clear.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }),
      });
      if (!response.ok) throw new Error('Unable to clear cart.');
      const result = await response.json();
      drawer.renderContents(result);
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gr-mini-cart-clear' });
      }
    } catch (exception) {
      button.removeAttribute('aria-disabled');
      button.textContent = 'CLEAR CART';
      const errors = drawer.querySelector('#CartDrawer-CartErrors');
      if (errors) errors.textContent = exception.message;
    }
  });
})();
